import { NoPreloading, Routes } from '@angular/router';
import { PreloadAllModules } from '@angular/router';

import { AuthenticationGuard } from './core';
import { LoginGuard } from '@app/auth/login.guard';

// Import standalone components
import { LoginComponent } from '@app/auth/components/login/login.component';
import { ChangePasswordComponent } from '@app/auth/components/change-password/change-password.component';
import { ResetPasswordComponent } from '@app/auth/components/reset-password/reset-password.component';

/**
 * Application routes using functional routing API
 * This replaces the old RouterModule.forRoot() pattern
 */
export const routes: Routes = [
  // Auth routes (outside of shell)
  {
    path: 'change-password/:token/:email',
    component: ChangePasswordComponent,
    data: { title: 'ChangePassword' }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: { title: 'Login' },
    canActivate: [LoginGuard]
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    data: { title: 'ResetPassword' },
    canActivate: [LoginGuard]
  },

  // Main application routes (inside shell)
  {
    path: '',
    loadChildren: () => import('./shell/shell.module').then(m => m.ShellModule)
  },

  // Fallback when no prior route is matched
  {
    path: '**',
    redirectTo: '/login'
  }
];

/**
 * Router configuration options
 */
export const routerConfig = {
  preloadingStrategy: NoPreloading,
  enableTracing: true // Set to true for debugging
};
